<script>
import VTooltip from "v-tooltip";
// VTooltip.options.autoHide = false;
export default {
	name: "certified-company",
	props: ["logo", "name", "url", "certificate", "categories"],
	data() {
		return {
			popup: false
		};
	},
	computed: {
		cleanedLogo() {
			return this.logo.replaceAll('&amp;', '&');
		},
	},
	methods: {
		reveal() {
			this.popup = true;
		},
		hide() {
			this.popup = false;
		},
		toggle() {
			this.popup = !this.popup;
		}
	}
};
</script>


<template>
    <div class="certified-company prel h-100">
		<v-popover class="h-100">
			<div class="tooltip-target b3 h-100 flex flex-column flex-justify-content-center flex-align-items-center">
				<img :src="cleanedLogo" alt="" class="w-100 db nomar"/>
			</div>

			<template slot="popover">			
				<h2 class="nomar" style="margin-top: 0;"><span v-html="name"></span></h2>
				<p class="is-size-7 has-text-grey"><span class="icon"><i class="fa fa-check"></i></span> Certified Company <br>
					<span v-for="category in categories" :key="category">
						<span class="icon"><i class="fa fa-tag"></i></span> 
						{{ category }}
					</span>
				</p>
				<a :href="url" class="button" target="_blank" v-if="url"><i class="fa fa-globe"></i> Visit website</a><br>
				<a :href="certificate" class="button" target="_blank" v-if="certificate"><i class="fa fa-file-pdf-o"></i> View certificate PDF</a>
			</template>
		</v-popover>
    </div>
</template>

<style>
.popup {
	position: absolute;
	bottom: -100%;
}
.tooltip-target {
	cursor: pointer;
}
.tooltip {
	display: block !important;
	z-index: 10000;

	.tooltip-inner {
		background: #60237b;
		color: white;
		border-radius: 5px;
		padding: 5px 8px 4px;
	}

	.tooltip-arrow {
		width: 0;
		height: 0;
		border-style: solid;
		position: absolute;
		margin: 5px;
		border-color: #60237b;
		z-index: 1;
	}

	&[x-placement^="top"] {
		margin-bottom: 5px;

		.tooltip-arrow {
			border-width: 5px 5px 0 5px;
			border-left-color: transparent !important;
			border-right-color: transparent !important;
			border-bottom-color: transparent !important;
			bottom: -5px;
			left: calc(50% - 5px);
			margin-top: 0;
			margin-bottom: 0;
		}
	}

	&[x-placement^="bottom"] {
		margin-top: 5px;

		.tooltip-arrow {
			border-width: 0 5px 5px 5px;
			border-left-color: transparent !important;
			border-right-color: transparent !important;
			border-top-color: transparent !important;
			top: -5px;
			left: calc(50% - 5px);
			margin-top: 0;
			margin-bottom: 0;
		}
	}

	&[x-placement^="right"] {
		margin-left: 5px;

		.tooltip-arrow {
			border-width: 5px 5px 5px 0;
			border-left-color: transparent !important;
			border-top-color: transparent !important;
			border-bottom-color: transparent !important;
			left: -5px;
			top: calc(50% - 5px);
			margin-left: 0;
			margin-right: 0;
		}
	}

	&[x-placement^="left"] {
		margin-right: 5px;

		.tooltip-arrow {
			border-width: 5px 0 5px 5px;
			border-top-color: transparent !important;
			border-right-color: transparent !important;
			border-bottom-color: transparent !important;
			right: -5px;
			top: calc(50% - 5px);
			margin-left: 0;
			margin-right: 0;
		}
	}

	&.popover {
		$color: #f9f9f9;

		.popover-inner {
			background: $color;
			color: #60237b;
			padding: 24px;
			border-radius: 2px;
			box-shadow: 0 5px 30px rgba(#60237b, 0.1);
		}

		.popover-arrow {
			border-color: $color;
		}
	}

	&[aria-hidden="true"] {
		visibility: hidden;
		opacity: 0;
		transition: opacity 0.15s, visibility 0.15s;
	}

	&[aria-hidden="false"] {
		visibility: visible;
		opacity: 1;
		transition: opacity 0.15s;
	}
}
.tooltip-arrow {
	z-index: 1;
}

.trigger {
	height: 100%;
}
</style>
